import React from "react";
import contactIcon1 from "../../assets/images/contact/1.png";
import contactIcon2 from "../../assets/images/contact/2.png";
import contactIcon3 from "../../assets/images/contact/3.png";
import shapeIcon1 from "../../assets/images/contact/4.png";

const ContactUs = () => {
  return (
    <div className="contact padding-top padding-bottom">
      <div className="container">
        <div className="contact__wrapper">
          <div className="row g-5">
            <div className="col-md-5">
              <div className="contact__info" dataAos="fade-right" dataAosDuration="1000">
                <div className="contact__social">
                  <h3>
                    let’s <span>get in touch</span> with us
                  </h3>
                  <ul className="social">
                    <li className="social__item">
                      <a href="#" className="social__link social__link--style4 active">
                        <i className="fab fa-facebook-f"></i>
                      </a>
                    </li>
                    <li className="social__item">
                      <a href="#" className="social__link social__link--style4">
                        <i className="fab fa-instagram"></i>
                      </a>
                    </li>
                    <li className="social__item">
                      <a href="#" className="social__link social__link--style4">
                        <i className="fab fa-linkedin-in"></i>
                      </a>
                    </li>
                    <li className="social__item">
                      <a href="#" className="social__link social__link--style4">
                        <i className="fab fa-youtube"></i>
                      </a>
                    </li>
                    <li className="social__item">
                      <a href="signin.html" className="social__link social__link--style4">
                        <i className="fab fa-twitter"></i>
                      </a>
                    </li>
                  </ul>
                </div>
                <div className="contact__details">
                  <div className="contact__item" dataAos="fade-right" dataAosDuration="1000">
                    <div className="contact__item-inner">
                      <div className="contact__item-thumb">
                        <span>
                          <img src={contactIcon1} alt="contact-icon" className="dark" />
                        </span>
                      </div>
                      <div className="contact__item-content">
                        <p>+234 7030 6675 04</p>
                        <p>+234 8145 1698 17</p>
                      </div>
                    </div>
                  </div>
                  <div className="contact__item" dataAos="fade-right" dataAosDuration="1100">
                    <div className="contact__item-inner">
                      <div className="contact__item-thumb">
                        <span>
                          <img src={contactIcon2} alt="contact-icon" className="dark" />
                        </span>
                      </div>
                      <div className="contact__item-content">
                        <p>protradesinsight@gmail.com</p>
                        <p>info@protradesinsight.org</p>
                      </div>
                    </div>
                  </div>
                  <div className="contact__item" dataAos="fade-right" dataAosDuration="1200">
                    <div className="contact__item-inner">
                      <div className="contact__item-thumb">
                        <span>
                          <img src={contactIcon3} alt="contact-icon" className="dark" />
                        </span>
                      </div>
                      <div className="contact__item-content">
                        <p>Lagos, Nigeria</p>
                        {/* <p>534 Victoria Trail</p> */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-7">
              <div className="contact__form">
                <form action="/" dataAos="fade-left" dataAosDuration="1000">
                  <div className="row g-4">
                    <div className="col-12">
                      <div>
                        <label htmlFor="name" className="form-label">
                          Name
                        </label>
                        <input className="form-control" type="text" id="name" placeholder="Full Name" />
                      </div>
                    </div>
                    <div className="col-12">
                      <div>
                        <label htmlFor="email" className="form-label">
                          Email
                        </label>
                        <input className="form-control" type="email" id="email" placeholder="Email here" />
                      </div>
                    </div>
                    <div className="col-12">
                      <div>
                        <label htmlFor="textarea" className="form-label">
                          Message
                        </label>
                        <textarea
                          cols="30"
                          rows="5"
                          className="form-control"
                          id="textarea"
                          placeholder="Enter Your Message"
                        ></textarea>
                      </div>
                    </div>
                  </div>
                  <button type="submit" className="trk-btn trk-btn--border trk-btn--primary mt-4 d-block">
                    Contact Us Now
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="contact__shape">
        <span className="contact__shape-item contact__shape-item--1">
          <img src={shapeIcon1} alt="shape-icon" />
        </span>
        <span className="contact__shape-item contact__shape-item--2">
          <span></span>
        </span>
      </div>
    </div>
  );
};

export default ContactUs;
